import { Component, OnInit } from '@angular/core';
import * as fileSaver from 'file-saver';
import { AchFraudScan, JobStatus } from '../../../models/job-models';
import { Pagination } from '../../../models/pagination';
import { AuthService } from '../../../services/auth.service';
import { ReportsService } from '../../../services/reports.service';
import { AppConfigService } from '../../../services/app-config.service';

@Component({
  selector: 'app-ach-scan',
  templateUrl: './ach-scan.component.html',
  styleUrls: ['./ach-scan.component.css'],
  standalone: false
})
export class AchScanComponent implements OnInit {
  canScan: boolean;
  pagination: Pagination = new Pagination();
  scans: AchFraudScan[];
  public jobStatus = JobStatus;

  constructor(
    public authService: AuthService,
    private reportService: ReportsService,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit() {
    if (this.appConfigService.getConfig().EnableACHFraudScan) {
      this.reportService.canScheduleAchScan().subscribe(resp => (this.canScan = resp));
    } else {
      this.canScan = false;
    }
    this._fetchScans();
  }

  public beginScan() {
    if (this.canScan) {
      this.reportService.scheduleAchScan().subscribe(() => this._fetchScans());
    }
  }

  public downloadScan(id: number) {
    this.reportService.GetAchFraudScanFile(id).subscribe(resp => {
      const scan = this.scans.find(x => x.Id == id);
      fileSaver.saveAs(
        resp,
        'Nightly ACH Fraud Scan ' + new Date(scan.CreatedOn).toISOString() + '.txt'
      );
    });
  }

  public loadPage({ Page }: Pagination) {
    this.pagination.Page = Page;
    this._fetchScans();
  }

  private _fetchScans() {
    this.reportService
      .getAchScans(this.pagination.Page, this.pagination.PerPage)
      .subscribe(resp => {
        this.scans = resp.Items;
        this.pagination = resp.Pagination;
      });
  }
}
